<template>
  <form id="donation-payment" class="card w-modal h-modal">
    <div class="header">
      <div class="title">
        <div class="flex flex-col">
          <h1 class="mb-2">New Donation</h1>
          <div class="flex flex-row">
            <h4 class="opacity-50">Supporter Details</h4>
            <h4 class="ml-4 mr-4 opacity-50">></h4>
            <h4 class="opacity-50">Donation Details</h4>
            <h4 class="ml-4 mr-4 opacity-50">></h4>
            <h4 class="opacity-50">Payment</h4>
            <h4 class="ml-4 mr-4">></h4>
            <h4>Receipt</h4>
          </div>
        </div>
      </div>
      <div class="close" @click="close()">
        <i class="icn icn-x sm"></i>
      </div>
    </div>
    <div class="content" v-if="payload.donation.paymentType == directDebit">
      <div class="flex flex-col items-center">
        <img class="h-40 mb-10 mt-20" src="@/assets/img/process_icon.svg" />
        <h1 class="mb-10">Donation #{{ payload.transaction.receiptNumber }} is under process</h1>
        <h1>The receipt will be sent when the payment is verified</h1>
      </div>
    </div>
    <div class="content" v-if="payload.donation.paymentType == creditCard">
      <div class="flex flex-col items-center">
        <img class="h-40 mb-10 mt-20" src="@/assets/img/tick_icon.svg" />
        <h1 class="mb-10">Payment accepted successfully</h1>
        <h1>Donation #{{ payload.transaction.receiptNumber }} has been processed</h1>
      </div>
      <div class="field mt-10" v-if="!emailIsSent">
        <form id="sending-receipt">
          <div class="row mt-2" v-if="payload.billingAddress.postalCode">
            <div class="field">
              <label>
                <input type="checkbox" v-model="sendPost" />
                Send the {{ payload.donation.type === 'Single' ? 'receipt' : 'confirmation' }} via post to
                {{ payload.addressFullLine }}
              </label>
            </div>
          </div>
          <div class="row mt-2">
            <div class="field">
              <label>
                <input type="checkbox" v-model="payload.sendReceiptToEmail" @change="checkCurrentEmail()" />
                Send the {{ payload.donation.type === 'Single' ? 'receipt' : 'confirmation' }} via email
              </label>
            </div>
          </div>
          <div v-if="payload.sendReceiptToEmail">
            <div class="row mt-2 ml-4" v-if="payload.supporter.email">
              <div class="field">
                <label>
                  <input type="checkbox" v-model="useCurrentEmail" />
                  Send to email {{ payload.supporter.email }}
                </label>
              </div>
            </div>
            <div class="row mt-2 ml-4">
              <div class="field">
                <label>
                  <input type="checkbox" v-model="useDifferentEmail" />
                  Send to a different email
                </label>
              </div>
            </div>
            <div v-if="useDifferentEmail" class="row mt-2 ml-4">
              <div class="field">
                <label>
                  <input type="text" v-model="differentEmail" placeholder="Email" />
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="field mt-10" v-if="emailIsSent"><alert :message="message"></alert></div>
    </div>
    <div class="footer">
      <button
        v-if="
          !isLoading &&
          payload.sendReceiptToEmail &&
          !emailIsSent &&
          ((useDifferentEmail && differentEmail) || (useCurrentEmail && payload.supporter.email))
        "
        type="button"
        @click="sendEmail()"
      >
        Send email
      </button>
      <button class="secondary" v-if="isLoading && !emailIsSent" type="button">
        <img class="h-6" src="@/assets/img/spinning.svg" />
      </button>
    </div>
  </form>
</template>

<script>
import Alert from '@/components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'DonationPayment',
  components: { Alert },
  data() {
    return {
      sendPost: true,
      useCurrentEmail: false,
      useDifferentEmail: false,
      differentEmail: null,
      emailIsSent: false,
      isLoading: false,
      message: null,
      creditCard: 'wwf_bbms',
      directDebit: 'wwf_directdebit',
    };
  },
  methods: {
    close() {
      this.$store.dispatch('donationModal/close');
      this.$store.dispatch('donationModal/reset');
    },
    checkCurrentEmail() {
      if (this.useCurrentEmail) {
        this.useDifferentEmail = false;
      }
    },
    checkDifferentEmail() {
      if (this.useDifferentEmail) {
        this.useCurrentEmail = false;
      }
    },
    async sendEmail() {
      try {
        this.isLoading = true;

        if (this.useCurrentEmail) {
          await this.$store.dispatch('donationModal/sendReceiptEmail', {
            email: this.payload.supporter.email,
            firstName: this.payload.supporter.firstName,
            lastName: this.payload.supporter.lastName,
            businessName: this.payload.donation.businessName,
            donationAmount: Number(this.payload.donation.amount),
            receiptNumber: this.payload.transaction.receiptNumber,
            transactionDate: this.payload.transaction.webGiftDate,
            donationType: this.payload.donation.type,
          });
        }

        if (this.useDifferentEmail) {
          await this.$store.dispatch('donationModal/sendReceiptEmail', {
            email: this.differentEmail,
            firstName: this.payload.supporter.firstName,
            lastName: this.payload.supporter.lastName,
            businessName: this.payload.donation.businessName,
            donationAmount: Number(this.payload.donation.amount),
            receiptNumber: this.payload.transaction.receiptNumber,
            transactionDate: this.payload.transaction.webGiftDate,
            donationType: this.payload.donation.type,
          });
        }

        let email = '';
        if (this.useCurrentEmail && this.useDifferentEmail) {
          email = `${this.payload.supporter.email} and ${this.differentEmail}`;
        } else if (this.useCurrentEmail) {
          email = this.payload.supporter.email;
        } else if (this.useDifferentEmail) {
          email = this.differentEmail;
        }

        this.message = {
          content: `Receipt #${this.payload.transaction.receiptNumber} has been sent to ${email}`,
          type: 'success',
        };
      } catch (_) {
        this.message = {
          content: `Cannot send email`,
          type: 'error',
        };
      } finally {
        this.emailIsSent = true;
        this.isLoading = false;
      }
    },
  },
  computed: {
    ...mapState({
      payload: (state) => state.donationModal.payload,
    }),
  },
};
</script>

<style></style>
